//global.baseUrlImage = "https://www.jurta.it/wp-content/uploads/wpallimport/files/"
//global.endpoint = "https://taralloapp.pegasogest.it/apiPegaso/"

global.aziendaID = window["configPegaso"].aziendaID;
global.baseUrlImage = window["configPegaso"].endPointBaseImage;
global.endpoint = window["configPegaso"].endPointBaseUrl;

/*global.aziendaID = 2;
global.baseUrlImage = "https://ordini-mondocarta.pegasogest.it/assets/img/articoli/mondoCarta/";
global.endpoint = "https://mondocartaapi.pegasogest.it/api/"; */

global.thrUpdPro = 600000;
global.timerLogin = 10800000;
global.inManutenzione = 0;
global.inManutenzioneDal = 1671749999000;
global.inManutenzioneAl = 1672959599000;
//global.endpoint = "https://dgaapi.pegasogest.it/api/"
global.endPointBaseImage = "https://pegaso3cloudapi.pegasogest.it/api/images/";
global.visualizzaPrezziLogOut = false;
global.visualizzaGrigliaLogOut = true;
global.visualizzaQuantitaLogOut = true;
global.prodottiSenzaLogin = true;
global.placeholderImage = window["configPegaso"].placeholderImage;
global.urlRedirectAfterLogin = window["configPegaso"].urlRedirectAfterLogin;
global.importoPortoFranco = window["configPegaso"].importoPortoFranco;
//http://79.10.23.214:8086/api
